import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb } from 'components';
import {
  Card,
  Tabs,
  Tab,
  Icon
} from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import { setSettingsActiveTab } from 'redux/actions/store_configs';
import { QuoteProSettingsIcon } from 'components/CustomSVG';
import StoreConfiguration from './StoreConfiguration';
import Configurations from './Configurations';
import GoLiveConfigs from './GoLiveConfigs';
import QuoteProSettings from './QuoteProConfig/QuoteProSettings';


const Settings = () => {
  const dispatch = useDispatch();
  const {hash} = useLocation();

  useEffect(() => {
    if (hash) {
      dispatch(setSettingsActiveTab(hash));
    }
  }, [hash]);

  const handleChangeTab = (value) => {
    dispatch(setSettingsActiveTab(value));
  };

  const {profile} = useSelector((state: IReduxState) => state.user);
  const isStoreLive = profile.stores?.[0]?.isLive;
  const isQuotingAvailable = !!profile.stores?.[0]?.quoteProStoreCode && !!profile.stores?.[0]?.quoteProStoreId;

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            {name: hash.replace(/#|_/g, (match) => match === '#' ? '' : ' ')}
          ]}
        />
      </div>
      <div className="mx-10">
        <Card className="p-8">
          <Tabs
            value={hash}
            onChange={(_, value) => handleChangeTab(value)}
            textColor="primary"
            indicatorColor="primary"
            aria-label="secondary tabs"
            className="mb-8"
          >
            {!isStoreLive &&
              <Tab
                label={<div className="flex items-center"><Icon className="mr-2">build_icon</Icon> Go Live Requirements</div>}
                value="#go_live_requirements"
                component={Link}
                className="capitalize font-bold flex items-center px-4"
                to="/settings#go_live_requirements"
              />
            }
            <Tab
              label={<div className="flex items-center"><Icon className="mr-2">app_settings_alt_icon</Icon> UI Configurations</div>}
              value="#UI_configurations"
              component={Link}
              className="capitalize font-bold flex items-center px-4"
              to="/settings#UI_configurations"
            />
            <Tab
              label={<div className="flex items-center"><SettingsIcon className="mr-2" /> Store Configurations</div>}
              value="#store_configurations"
              component={Link}
              className="capitalize font-bold flex items-center px-4"
              to="/settings#store_configurations"
            />
            {isQuotingAvailable &&
              <Tab
                label={
                  <div className="flex items-center">
                    <span style={{ color: '#000'}}><QuoteProSettingsIcon className="mr-2 mt-1" active={hash === '#QuotePRO_configurations'} /></span>QuotePRO Configurations
                  </div>}
                value="#QuotePRO_configurations"
                component={Link}
                className="capitalize font-bold flex items-center px-4"
                to="/settings#QuotePRO_configurations"
              />
            }
          </Tabs>
          {hash === '#UI_configurations' && <Configurations />}
          {hash === '#store_configurations' && <StoreConfiguration />}
          {hash === '#QuotePRO_configurations' && <QuoteProSettings />}
          {hash === '#go_live_requirements' &&
            !isStoreLive && <GoLiveConfigs />
          }
        </Card>
      </div>
    </div>
  );
};

export default Settings;
